<template>
  <div>
    <Nav v-if="!isMobile" />
    <MNav v-if="isMobile" />
    <router-view />
  </div>
</template>
<script>
import MNav from './components/MNav.vue'
import Nav from './components/Nav.vue'
import { useStore } from 'vuex'
import { useMediaQuery } from '@vueuse/core'
import { onMounted, computed, onBeforeMount, toRaw} from 'vue'
export default {
  components: { Nav, MNav },
  setup() {
    const store = useStore()
    const web3 = computed(() => {
      return store.state.web3
    })
    const network = computed(() => {
      return store.state.network
    })
    const address = computed(() => {
      return store.state.address
    })
    const isMobile = computed(() => {
      return store.state.isMobile
    })
    const fn = () => {
      let ethereum = window.ethereum
      ethereum.on("accountsChanged", (accounts) => {
        console.log("账号切换", accounts[0])
        if (!accounts[0]) {
          store.commit('init')
        } else {
          store.commit('getWeb3')
        }
      })
      ethereum.on("chainChanged", (chainId) => {
        console.log("用户切换了链", chainId)
        store.commit('getWeb3')
      })
    }
    onBeforeMount(() => {
      let isMobile = useMediaQuery('(max-width: 820px)')
      store.commit("setIsMobile", toRaw(isMobile.value))
      window.addEventListener('resize', () => {
        let isMobile = useMediaQuery('(max-width: 820px)')
        store.commit("setIsMobile", toRaw(isMobile.value))
      })
    })
    onMounted(() => {
      store.commit("getWeb3", true)
      fn()
    })
    return {
      web3,
      network,
      address,
      isMobile
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  background: #101013;
  width: 100vw;
}

</style>
